export { default as CarouselArrow } from "./CarouselArrow.vue";
export { default as Media } from "./Media.vue";
export { default as MediaCarousel } from "./MediaCarousel.vue";
export { default as MediaViewer } from "./MediaViewer.vue";

export const supportedMimeTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "video/mp4",
    "video/quicktime",
    "video/ogg",
    "video/webm",
    "application/pdf",
];

export function isSupportedMedia(mime_type) {
    return supportedMimeTypes.includes(mime_type);
}
